import '../navbar/navbar.scss';
import { useContext } from 'react';
import { DarkModeContext } from '../../context/darkModeContext';
import { useNavbarLogic } from './hooks/useNavbarLogic';
import NavbarLeft from './components/NavbarLeft';
import NavbarRight from './components/NavbarRight';
import UserMenu from './components/UserMenu';
import LogoutModal from './components/LogoutModal';

const Navbar = () => {
    const { darkMode, toggle } = useContext(DarkModeContext);
    const { 
        state, 
        setters, 
        actions, 
        currentUser 
    } = useNavbarLogic();

    return (
        <div className='navbar'>
            <NavbarLeft 
                darkMode={darkMode} 
                toggleDarkMode={toggle} 
            />

            <NavbarRight
                currentUser={currentUser}
                notificationOpen={state.notificationOpen}
                setNotificationOpen={setters.setNotificationOpen}
                closeUserDropdown={actions.closeUserDropdown}
            >
                <UserMenu 
                    currentUser={currentUser}
                    isOpen={state.dropdownOpen}
                    toggle={actions.toggleDropdown}
                    onLogoutRequest={actions.handleLogoutClick}
                />
            </NavbarRight>

            <LogoutModal 
                isOpen={state.showLogoutModal}
                darkMode={darkMode}
                onConfirm={actions.confirmLogout}
                onCancel={actions.cancelLogout}
            />
        </div>
    );
};

export default Navbar;